<template>
    <v-container class="wrapper pa-0">
        <v-card class="pa-2 ma-0 product-wrapper">
            <!--header-->
            <v-container class="pa-0 header">
                <div class="w-60 d-flex flex-column gap-2">
                    <div class="d-flex justify-space-between align-center w-100 gap-1">
                        <div class="queue-wrapper">
                            <div 
                                ref="factorsQueue"
                                class="factors-queue"
                            >
                                <div
                                    v-for="(inv, index) in invoices"
                                    :key="index"
                                    class="child"
                                    :class="{ 'active' : inv.number == activeInv }"
                                    @click="selectInvoice(inv)"
                                >
                                    <span class="text-caption">
                                        {{ $t('invoice') }} ({{ inv.number }})
                                    </span>
                                    <v-icon 
                                        @click="askPermission(inv)"
                                        size="10" 
                                        style="cursor: pointer;"
                                    >
                                    mdi-close
                                    </v-icon>
                                </div>
                            </div>
                            <div 
                                @click="addInvoice"
                                class="fix-btn"
                            >
                                <div class="add-btn child">
                                    <v-icon size="14">mdi-plus</v-icon>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-center" style="gap: .2rem;">
                            <v-btn
                                color="secondary"
                                outlined
                                height="34"
                                @click="scrollQueue('right')"
                            >
                            <v-icon size="19">mdi-chevron-right</v-icon>
                            </v-btn>
                            <v-btn
                                color="secondary"
                                outlined
                                height="34"
                                @click="searchInvDialog = true"
                            >
                                <span class="ml-2">{{ $t('invoice') }}</span>
                                <v-icon size="15">mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn
                                color="secondary"
                                outlined
                                height="34"
                                @click="scrollQueue('left')"
                            >
                            <v-icon size="19">mdi-chevron-left</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <v-form ref="form">
                        <div class="d-flex gap-2">
                            <autocomplete
                                ref="refAccount"
                                v-model="newInvoice.account"
                                :title="$t('account')"
                                type="person"
                                :new-btn="true"
                                :rules="[v => !!v || $t('is-required')]"
                                :value="newInvoice.account"
                            />
                            <template>
                                <v-text-field
                                    id="date"
                                    v-model="newInvoice.date"
                                    :label="$t('date')"
                                    :rules="[v => !!v || $t('is-required')]"
                                    clear-icon="flaticon2-close-cross"
                                    outlined
                                    hide-details
                                    dense
                                    clearable
                                />
                                <date-picker
                                    v-model="newInvoice.date"
                                    element="date"
                                    :locale="$store.state.date_locale"
                                    :format="$store.state.date_format"
                                    auto-submit
                                    :min="$store.state.startDate"
                                    :max="$store.state.endDate"
                                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                                    @close="setDate"
                                />
                            </template>
                            <v-text-field
                                v-model="newInvoice.number"
                                height="20"
                                dense
                                :rules="[v => !!v || $t('is-required')]"
                                outlined
                                class="dense"
                                clearable
                                :label="$t('invoic-number')"
                                ref="number"
                            />
                            <autocomplete
                                ref="refEntrepot"
                                v-model="newInvoice.entrepot"
                                title="chose-entrepot"
                                type="entrepot"
                                :new-btn="true"
                                :value="newInvoice.entrepot"
                            />
                        </div>
                    </v-form>
                </div>
                <div class="w-10 d-flex flex-column gap-2">
                    <v-btn
                        color="secondary"
                        outlined
                        height="34"
                        class="flex-fill"
                        disabled
                    >
                        <span>{{ $t('layout') }}</span>
                    </v-btn>
                    <div>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                            class="w-100"
                            :loading="loading"
                            @click="fetchAllProducts = true"
                        >
                            <span>{{ $t('product') }}/{{ $t('service') }} ({{ $t('all') }})</span>
                        </v-btn>
                    </div>
                </div>
                <div class="w-30 d-flex flex-column gap-2">
                    <div class="d-flex gap-2">
                        <div class="flex-fill">
                            <offlineProductAutocomplete
                                v-model="product"
                                title="productName"
                                type="product"
                            />
                        </div>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                        >
                            <span class="ml-1">{{ $t('product') }} / {{ $t('service') }}</span>
                            <v-icon size="15">mdi-plus</v-icon>
                        </v-btn>
                    </div>
                    <div class="d-flex gap-2">
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                        >
                            <v-icon size="15">mdi-collage</v-icon>
                            <span class="mr-1">{{ $t('otherProduct') }}</span>
                        </v-btn>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                            class="flex-fill text-start"
                            disabled
                        >
                            <v-icon size="15">mdi-sort</v-icon>
                            <span class="mr-1">{{ $t('optional-order') }}</span>
                        </v-btn>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                            @click="gridTwoLayer = !gridTwoLayer"
                        >
                            <my-icon
                                v-if="gridTwoLayer"
                                :name="'four-grid-layout'"
                                :width="18"
                                :height="18"
                                :cursor-pointer="true"
                            />
                            <my-icon
                                v-else
                                :name="'two-grid-layout'"
                                :width="18"
                                :height="18"
                                :cursor-pointer="true"
                            />
                        </v-btn>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                            @click="imgVisibility = !imgVisibility"
                        >
                            <my-icon
                                v-if="imgVisibility"
                                :name="'no-image'"
                                :width="18"
                                :height="18"
                                :cursor-pointer="true"
                            />
                            <my-icon
                                v-else
                                :name="'has-image'"
                                :width="18"
                                :height="18"
                                :cursor-pointer="true"
                            />
                        </v-btn>
                        <v-btn
                            color="secondary"
                            outlined
                            height="34"
                            disabled
                        >
                            <v-icon size="18">mdi-filter-outline</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-container>
            <!--body-->
            <v-container class="pa-0 pt-2 body">
                <div class="w-60" >
                    <product-list />
                </div>
                <div class="w-10 c-category">
                    <product-category 
                        :fetchAllProducts="fetchAllProducts"
                        @productsFetched="fetchAllProducts = false"
                        @loadingStatus="loadingStatusHandler"
                    />
                </div>
                <div class="w-30">
                    <product-shortcut 
                        :gridTwoLayer="gridTwoLayer"
                        :imgVisibility="imgVisibility"
                    />
                </div>
            </v-container>
        </v-card>
        <v-container class="pa-0 calc-wrapper" style="background-color: silver;">
            
        </v-container>
        <PermissionDialog
            :askPerm="askPerm"
            :txtPerm="txtPerm"
            :detailPerm="detailPerm"
            :dialogWidth="dialogWidth"
            :permType="permType"
            :btnTxt="btnTxt"
            @accept="accept"
            @deny="askPerm = false"
        />
        <!-- <InvoiceSearch
            :isDialogVisible="searchInvDialog"
            @searchInvClosed="searchInvDialog = false"
            :invoiceType="invoiceType"
            @onSelectedRow="selectRowHandler"
        /> -->
    </v-container>
</template>

<script>
import General from '@/Mixins/general.js'
import MyIcon from '@/views/dashboard/components/general/icon/MyIcon.vue'
import productList from '@/views/dashboard/pages/invoice/CashRegister/partial/ProductTable.vue'
import productCategory from '@/views/dashboard/pages/invoice/CashRegister/partial/ProductCategory.vue'
import productShortcut from '@/views/dashboard/pages/invoice/CashRegister/partial/ProductShortcut.vue'
import Composite from '@/views/dashboard/pages/invoice/partial/Composite.vue'
import segmentDisplay from '@/views/dashboard/components/general/7segment/index.vue'
import PermissionDialog from '@/views/dashboard/pages/invoice/CashRegister/partial/PermissionDialog.vue'
import InvoiceSearch from '@/views/dashboard/pages/invoice/CashRegister/partial/InvoiceSearch.vue'

export default {
    mixins: [General],
    data() {
        return {
            newInvoice: {
                id: null,
                number: null,
                account: null,
                date: null,
                entrepot: null,
                currency: null,
                branch: null,
                type: null,
                given: null,
                content: null,
                composite: null,
                credit: null,
                credit_status: null,
                products: [],
                price: {
                    total: null,
                    discount: null,
                    discount_percent: null,
                    tax: null,
                    tax_percent: null,
                    payment: null,
                    remain: null,
                    sum: null
                }
            },
            invoices: [],
            activeInv: null,
            askPerm: false,
            txtPerm: null,
            detailPerm: null,
            dialogWidth: null,
            permType: null,
            btnTxt: null,
            selectedInv: null,
            searchInvDialog: false,
            fetchAllProducts: false,
            loading: false,
            gridTwoLayer: true,
            imgVisibility: true
        }
    },
    components: {
        productList,
        productCategory,
        productShortcut,
        MyIcon,
        Composite,
        segmentDisplay,
        PermissionDialog,  
        InvoiceSearch,
        offlineProductAutocomplete: () => import('@/views/dashboard/components/general/Products/offlineProductAutocomplete.vue')
    },
    beforeMount () {
        this.getInvoiceNumber()


    },
    mounted () {
        this.setIndexDB()


    },
    methods: {
        getInvoiceNumber () {
            var app = this
            app.loading = true
            app.$axios.get(app.$endpoint + 'getdetail', {
                params: {
                    type: 'sell',
                    select: 'getInvoiceNumber',
                }
            })
            .then(r => {
                const newInvoiceNum = r.data
                if (newInvoiceNum) {
                    app.newInvoice.number = newInvoiceNum.number
                    app.invoices.push({ ...app.newInvoice })
                    app.activeInv = app.newInvoice.number
                }
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.loading = false))
        },
        addInvoice () {
            if (this.invoices && this.invoices.length > 0) {
                const lastInvNum = this.invoices[this.invoices.length -1].number
                Object.keys(this.newInvoice).forEach(key => {
                    if (key !== 'price') {
                        this.newInvoice[key] = null
                    }
                })
                Object.keys(this.newInvoice.price).forEach(key => {
                    this.newInvoice.price[key] = null
                })
                this.newInvoice.number = lastInvNum + 1
                this.$refs.form.resetValidation()
                this.invoices.push({ ...this.newInvoice })
                this.activeInv = this.newInvoice.number
            }
        },
        selectInvoice (inv) {
            const selectedInv = this.invoices.find(obj => obj.number == inv.number)
            this.activeInv = selectedInv.number
            this.newInvoice =  {
                id: selectedInv.id,
                number: selectedInv.number,
                account: selectedInv.account,
                date: selectedInv.date,
                entrepot: selectedInv.entrepot,
                currency: selectedInv.currency,
                branch: selectedInv.branch,
                type: selectedInv.type,
                given: selectedInv.given,
                content: selectedInv.content,
                composite: selectedInv.composite,
                credit: selectedInv.credit,
                credit_status: selectedInv.credit_status,
                products: selectedInv.products,
                price: {
                    total: selectedInv.total,
                    discount: selectedInv.discount,
                    discount_percent: selectedInv.discount_percent,
                    tax: selectedInv.tax,
                    tax_percent: selectedInv.tax_percent,
                    payment: selectedInv.payment,
                    remain: selectedInv.remain,
                    sum: selectedInv.sum
                }
            }
        },
        askPermission (inv) {
            this.askPerm = true
            this.permType = true
            this.txtPerm = this.$t('are-you-sure-delete-this-case')
            this.detailPerm = this.$t('invoice-number') + ' : ' + inv.number
            this.dialogWidth = 300
            this.selectedInv = inv
        },
        accept () {
            const removedInv = this.invoices.findIndex(obj => obj.number == this.selectedInv.number)
            if (removedInv != -1) {
                if (removedInv == 0 && this.invoices.length == 1) {
                    return false
                } else {
                    this.invoices.splice(removedInv, 1)
                }

                const firstInv = removedInv == 0
                const middleInv = removedInv > 0 && removedInv <= this.invoices.length - 1
                const lastInv = removedInv == this.invoices.length

                // if it was first invoice and still there are other invoices to switch
                if (firstInv && this.invoices.length > 0) {
                    this.activeInv = this.invoices[0].number
                    this.newInvoice =  {
                        id: this.invoices[0].id,
                        number: this.invoices[0].number,
                        account: this.invoices[0].account,
                        date: this.invoices[0].date,
                        entrepot: this.invoices[0].entrepot,
                        currency: this.invoices[0].currency,
                        branch: this.invoices[0].branch,
                        type: this.invoices[0].type,
                        given: this.invoices[0].given,
                        content: this.invoices[0].content,
                        composite: this.invoices[0].composite,
                        credit: this.invoices[0].credit,
                        credit_status: this.invoices[0].credit_status,
                        products: this.invoices[0].products,
                        price: {
                            total: this.invoices[0].total,
                            discount: this.invoices[0].discount,
                            discount_percent: this.invoices[0].discount_percent,
                            tax: this.invoices[0].tax,
                            tax_percent: this.invoices[0].tax_percent,
                            payment: this.invoices[0].payment,
                            remain: this.invoices[0].remain,
                            sum: this.invoices[0].sum
                        }
                    }
                }
                // if it was middle invoive and has neighbers before and after
                if (middleInv) {
                    this.activeInv = this.invoices[removedInv].number
                    this.newInvoice =  {
                        id: this.invoices[removedInv].id,
                        number: this.invoices[removedInv].number,
                        account: this.invoices[removedInv].account,
                        date: this.invoices[removedInv].date,
                        entrepot: this.invoices[removedInv].entrepot,
                        currency: this.invoices[removedInv].currency,
                        branch: this.invoices[removedInv].branch,
                        type: this.invoices[removedInv].type,
                        given: this.invoices[removedInv].given,
                        content: this.invoices[removedInv].content,
                        composite: this.invoices[removedInv].composite,
                        credit: this.invoices[removedInv].credit,
                        credit_status: this.invoices[removedInv].credit_status,
                        products: this.invoices[removedInv].products,
                        price: {
                            total: this.invoices[removedInv].total,
                            discount: this.invoices[removedInv].discount,
                            discount_percent: this.invoices[removedInv].discount_percent,
                            tax: this.invoices[removedInv].tax,
                            tax_percent: this.invoices[removedInv].tax_percent,
                            payment: this.invoices[removedInv].payment,
                            remain: this.invoices[removedInv].remain,
                            sum: this.invoices[removedInv].sum
                        }
                    }
                }
                // if it was last invoice 
                if (lastInv) {
                    this.activeInv = this.invoices[this.invoices.length - 1].number
                    this.newInvoice =  {
                        id: this.invoices[this.invoices.length - 1].id,
                        number: this.invoices[this.invoices.length - 1].number,
                        account: this.invoices[this.invoices.length - 1].account,
                        date: this.invoices[this.invoices.length - 1].date,
                        entrepot: this.invoices[this.invoices.length - 1].entrepot,
                        currency: this.invoices[this.invoices.length - 1].currency,
                        branch: this.invoices[this.invoices.length - 1].branch,
                        type: this.invoices[this.invoices.length - 1].type,
                        given: this.invoices[this.invoices.length - 1].given,
                        content: this.invoices[this.invoices.length - 1].content,
                        composite: this.invoices[this.invoices.length - 1].composite,
                        credit: this.invoices[this.invoices.length - 1].credit,
                        credit_status: this.invoices[this.invoices.length - 1].credit_status,
                        products: this.invoices[this.invoices.length - 1].products,
                        price: {
                            total: this.invoices[this.invoices.length - 1].total,
                            discount: this.invoices[this.invoices.length - 1].discount,
                            discount_percent: this.invoices[this.invoices.length - 1].discount_percent,
                            tax: this.invoices[this.invoices.length - 1].tax,
                            tax_percent: this.invoices[this.invoices.length - 1].tax_percent,
                            payment: this.invoices[this.invoices.length - 1].payment,
                            remain: this.invoices[this.invoices.length - 1].remain,
                            sum: this.invoices[this.invoices.length - 1].sum
                        }
                    }
                }
            }
        },
        scrollQueue (direction) {
            const factorsQueue = this.$refs.factorsQueue
            if (direction === 'left') {
                factorsQueue.scrollLeft -= 100
            } else if (direction === 'right') {
                factorsQueue.scrollLeft += 100
            }
        },
        loadingStatusHandler (val) {
            this.loading = val
        },
        setIndexDB () {
            var invoiceluncher = localStorage.getItem('invoiceLuncher')
            if (!invoiceluncher) {
                localStorage.setItem('invoiceLuncher', 'dbCreated')
            }
            if (invoiceluncher === 'dbCreated') {
                // creating database in (indexDB) + insert data inside + download newest version webapp
                localStorage.setItem('invoiceLuncher', 'dataSet')
                this.getAllProductsOffline('product')
                this.$store.commit('SET_RELOAD', true)

                this.askPerm = true
                this.txtPerm = this.$t('indexCategoryHelpContent')
                this.dialogWidth = 400
                this.permType = false
                this.btnTxt = this.$t('downloadSoftware')
            }
        }
    },
    watch: {
        invoices (val) {
            if (val) {
                localStorage.setItem('invoices', JSON.stringify(this.invoices))
            }
        },
        newInvoice: {
            handler (val) {
                if (val.number) {
                    const invoiceIndex = this.invoices.findIndex(inv => inv.number == val.number)
                    if (invoiceIndex !== -1) {
                        // update
                        this.$set(this.invoices, invoiceIndex, { ...val })
                    } else {
                        // create
                        this.invoices.push({ ...val })
                    }
                }
            },
            deep: true
        }
    }

}
</script>

<style scoped>
.wrapper {
    height: calc(100vh - 94px);
    display: flex;
    flex-direction: column;
}
.wrapper .product-wrapper {
    flex: 7.5;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
.wrapper .product-wrapper .header {
    display: flex;
    gap: .5rem;
    width: 100%;
}
.wrapper .product-wrapper .header .queue-wrapper {
  display: flex;
  flex: 1;
  min-width: 0;
}
.wrapper .product-wrapper .header .queue-wrapper .factors-queue {
    border: 1px solid silver;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scrollbar-width: none;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; 
    scroll-behavior: smooth;
}
.wrapper .product-wrapper .header .factors-queue .child {
    padding: 7px 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    border-left: 1px solid silver;
    height: 100%;
    cursor: pointer;
    /* flex: 0 0 auto;
    max-width: 100px;
    width: 100px; */
}
.wrapper .product-wrapper .header .factors-queue .child.active {
    background-color: #0066FF;
    color: #fff;
}
.wrapper .product-wrapper .header .factors-queue .child.active:first-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.wrapper .product-wrapper .header .factors-queue .child.active .v-icon {
    color: #fff;
}
.wrapper .product-wrapper .header .factors-queue .child:last-child {
    border-left: none;
}
.wrapper .product-wrapper .header .fix-btn {
    border: 1px solid silver;
    border-radius: 4px;
    padding: 3.1px 9px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex: 0 0 auto;   
}
.wrapper .product-wrapper .body {
    display: flex;
    flex: 1;
    gap: .5rem;
    min-height: 0;
}
.wrapper .product-wrapper .body .c-category {
    height: 100%;
    min-height: 0;
    overflow: auto;
    scrollbar-width: none;
}
.wrapper .calc-wrapper {
    flex: 2.5;
}
.w-60 {
    width: 60%;
}
.w-10 {
    width: 8%;
}
.w-30 {
    width: 31%;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
.v-btn:not(.v-btn--round).v-size--default {
    min-width: auto !important;
}
.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding: 7px !important;
}
::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
}
.fixed-bottom-payment {
    background-color: #fff;
    border-top: 1px solid #c0c0c07a;
}
.fullscreen .fixed-bottom-payment {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.fixed-bottom-payment .wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:nth-child(2) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.fixed-bottom-payment .header-total {
  border: 1.5px solid #0066ff;
  padding: 0 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.v-card__text {
  width: auto;
}
.fixed-bottom-payment .body-total {
  border: 1.5px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
.v-btn--is-elevated {
  box-shadow: none !important;
}
.v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}
::v-deep .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls__input {
    margin-left: 0;
}
::v-deep .v-btn--icon.v-size--small .v-icon,
::v-deep .v-input__append-inner .v-input__icon .v-icon {
  margin-top: 8px;
}

</style>
